export default __webpack_public_path__ + "static/media/Kasperable.b46a29fe.jpg";